import { createTheme, ThemeOptions } from "@mui/material/styles";
import sbComponents from "./sbComponents";
import sbMixins from "./sbMixins";
import { sbDarkPalette, sbPalette } from "./sbPalette";
import sbTypography from "./sbTypography";
import sbZindex from "./sbZIndex";

const sbThemeOptions: ThemeOptions = {
  typography: sbTypography,
  mixins: sbMixins,
  components: sbComponents,
  zIndex: sbZindex,
};

export const sbTheme = createTheme({
  ...sbThemeOptions,
  colorSchemes: {
    light: {
      palette: sbPalette,
    },
    dark: {
      palette: sbDarkPalette,
    },
  },
});
